var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasurement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 59,
    viewBox: "0 0 70 59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-853.000000, -759.000000) translate(735.000000, 760.000000) translate(119.000000, 0.000000)",
    stroke: "#000",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.809999957,5.82645043e-13 L0.809999957,56.051997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5215964,5.82645043e-13 L67.5215964,56.051997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7169993,28.0421985 L55.5821971,28.0421985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8257988,39.2687979 L13.4297993,29.9375984 C12.9628368,29.4751415 12.7001179,28.845205 12.7001179,28.1879985 C12.7001179,27.530792 12.9628368,26.9008555 13.4297993,26.4383986 L22.9067988,16.7183991"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5057976,16.7831991 L54.9017971,26.1143986 C55.3687596,26.5768555 55.6314785,27.206792 55.6314785,27.8639985 C55.6314785,28.521205 55.3687596,29.1511415 54.9017971,29.6135984 L45.4247976,39.3335979"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurement);
export default __webpack_public_path__ + "static/media/measurement.713198ed23a452ffc2e92c810827bda4.svg";
export { ForwardRef as ReactComponent };